var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showRecommendButton)?_c('el-button',{attrs:{"type":"plain","loading":_vm.recommendButtonLoading},on:{"click":_vm.recommendToLibrary}},[_vm._v(" 推荐我的图书馆购买 ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }